exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact {\n  min-height: 600px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/src/app/pages/contact/contact.component.scss
// module id = ../../../../../src/app/pages/contact/contact.component.scss
// module chunks = 0